import axios from "axios";
import { refreshToken, REFRESH_TOKEN_KEY, LoginContextProvider } from "@bindeleddet/core/contexts/login";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json";

// "ResizeObserver loop completed with undelivered notifications" is a benign browser
// warning (a ResizeObserver callback triggered another resize within the same frame;
// the browser defers it to the next frame and warns, nothing is actually broken) - see
// https://github.com/WICG/resize-observer/issues/38. Several antd v5 components use
// ResizeObserver internally and can trigger it. CRA's dev-server error overlay treats
// any window "error" event as a blocking full-screen error, so it needs silencing here
// rather than left to bubble up.
window.addEventListener("error", event => {
  if (event.message === "ResizeObserver loop completed with undelivered notifications.") {
    event.stopImmediatePropagation();
  }
});

axios.interceptors.response.use(
  response => response,
  async error => {
    const storedRefreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);

    // If the error code is 401 Unauthorized and we have a refresh token, try to refresh the token
    if (error.response?.status === 401 && storedRefreshToken) {
      try {
        await refreshToken();
        const originalRequest = error.config;
        originalRequest.headers.Authorization = axios.defaults.headers.common.Authorization;
        return axios(originalRequest);
      } catch (err) {
        // If refresh token fails, return the original error
        return Promise.reject(error);
      }
    }

    // Otherwise, return the original error
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <LoginContextProvider>
    <App />
  </LoginContextProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
